import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Flex, Typography } from 'antd'
import Image from 'src/app/shared/components/common/common-image'
import { CHECK_EXCEPTION_DETAIL } from '../constants/index.model'
import './index.scss'

interface CheckImagesProps {
  checkExceptionDetail: CHECK_EXCEPTION_DETAIL
}

function CheckImage({ checkExceptionDetail }: CheckImagesProps) {
  const { t } = useTranslation()
  const [selected, setSelected] = useState(0)
  const { frontImagePath, backImagePath, checkNumber } = checkExceptionDetail
  const toggleItems = [
    {
      key: 0,
      label: t('OverallFunctionality:check_images_front_btn'),
      img: frontImagePath,
    },
    {
      key: 1,
      label: t('OverallFunctionality:check_images_back_btn'),
      img: backImagePath,
    },
  ]
  return (
    <Flex vertical gap={16} className='check-images' align={'center'}>
      <Flex justify='space-between' align='center' className='image-sides-container'>
        <Flex className='toggle-wrap' gap={4}>
          {toggleItems.map((item) => (
            <div
              key={item.key}
              className={`${selected === item.key ? 'selected' : ''} toggle-item`}
              onClick={() => setSelected(item.key)}
            >
              <Typography.Text>{item.label}</Typography.Text>
            </div>
          ))}
        </Flex>
      </Flex>

      <Image checkNumber={checkNumber} width={'100%'} height={350} src={toggleItems[selected]?.img} />
    </Flex>
  )
}

export default CheckImage
